export class SettingsService {
  constructor($resource, AuthService, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.authService = AuthService;
    this.apiService = ApiService;

    const endpoint = this.apiService.getResourceUrl("/settings/:settingName");
    this.resource = this.$resource(endpoint, null, {
      update: {
        method: "PUT",
      },
    });
  }

  getSettings() {
    return this.resource.get().$promise;
  }

  getSettingDetails({ settingName }) {
    const promise = this.resource.get({ settingName }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  updateSettingDetails(settingName, details) {
    const promise = this.resource.update({ settingName }, details).$promise;

    return promise
      .then((details) => details)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/settings/settings.service.js